/* @ngInject */
function requestDeduplicationService ($q) {
  const pendingRequests = new Map()
  const responseCache = new Map()
  const CACHE_DURATION = 30000 // 30 segundos em milissegundos

  const service = {
    deduplicateRequest,
    clearCache,
    clearPendingRequests,
    getCacheSize: () => responseCache.size,
    getPendingSize: () => pendingRequests.size
  }

  return service

  /**
   * Deduplica requisições HTTP baseadas na URL e método
   * @param {string} key - Chave única para a requisição (geralmente URL + método)
   * @param {Function} requestFunction - Função que executa a requisição HTTP
   * @param {number} cacheTimeMs - Tempo de cache em milissegundos (opcional)
   * @returns {Promise} Promise da requisição
   */
  function deduplicateRequest (key, requestFunction, cacheTimeMs = CACHE_DURATION) {
    // Verifica se há resposta em cache ainda válida
    const cachedResponse = getCachedResponse(key)
    if (cachedResponse) {
      return $q.resolve(cachedResponse.data)
    }

    // Verifica se há uma requisição pendente para a mesma chave
    if (pendingRequests.has(key)) {
      return pendingRequests.get(key)
    }

    // Cria nova requisição

    let requestPromise

    try {
      requestPromise = requestFunction()
        .then(response => {
          // Armazena resposta no cache
          setCachedResponse(key, response, cacheTimeMs)
          // Remove da lista de pendentes
          pendingRequests.delete(key)
          return response
        })
        .catch(error => {
          // Remove da lista de pendentes em caso de erro
          pendingRequests.delete(key)
          return $q.reject(error)
        })
    } catch (error) {
      // Handle synchronous exceptions
      pendingRequests.delete(key)
      requestPromise = $q.reject(error)
    }

    // Armazena a promise pendente
    pendingRequests.set(key, requestPromise)

    return requestPromise
  }

  /**
   * Obtém resposta do cache se ainda estiver válida
   */
  function getCachedResponse (key) {
    const cached = responseCache.get(key)
    if (!cached) {
      return null
    }

    const now = Date.now()
    if (now > cached.expiresAt) {
      responseCache.delete(key)
      return null
    }

    return cached
  }

  /**
   * Armazena resposta no cache com tempo de expiração
   */
  function setCachedResponse (key, data, cacheTimeMs) {
    const expiresAt = Date.now() + cacheTimeMs
    responseCache.set(key, {
      data,
      expiresAt,
      createdAt: Date.now()
    })
  }

  /**
   * Limpa todo o cache de respostas
   */
  function clearCache () {
    responseCache.clear()
  }

  /**
   * Limpa todas as requisições pendentes
   */
  function clearPendingRequests () {
    pendingRequests.clear()
  }
}

export { requestDeduplicationService }
